import React, { useMemo } from 'react';
import Overlay from '@/components/atoms/overlay';
import toast from '@/components/atoms/toaster/helpers/toast';
import ProductViewModal from '@/components/molecules/product-view-modal';
import { useProduct } from '@/lib/hooks/useProduct';
import useCart from '@/lib/hooks/useCart';
import useStores from '@/lib/hooks/useStores';
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import { useStoreAndBusinessUnits } from '@/providers/store-and-business-units';
import { mapProduct } from '@/utils/mappers/map-product';
import { Props } from './types';

const AddItemToCartForm = ({ close, productSuggestion }: Props) => {
  const { translate } = useTranslation();
  const { selectedBusinessUnit, selectedStore } = useStoreAndBusinessUnits();
  const { priceChannel, channel } = useStores();

  const fetchedProduct = useProduct(
    productSuggestion
      ? {
          sku: productSuggestion.sku,
          businessUnitKey: selectedBusinessUnit?.key,
          storeKey: selectedStore?.key,
          customerCategoryChannelKey: channel?.key,
          distributionChannelId: priceChannel?.key,
        }
      : undefined,
    !!productSuggestion,
  );

  const product = useMemo(() => fetchedProduct && mapProduct(fetchedProduct), [fetchedProduct]);

  const { addItem } = useCart(selectedBusinessUnit?.key, selectedStore?.key);

  return (
    <>
      {product && (
        <>
          <Overlay zIndex="z-[315]" />
          <ProductViewModal
            item={product}
            close={close}
            onAddToCart={async (count: number) => {
              let res;
              if (product.sku) {
                res = await addItem([{ sku: product.sku, count, isPreOrder: false }], priceChannel?.channelId);
              }
              if (!res?.success) toast.error(res?.message || translate('common.something.went.wrong'));
              else {
                close();
              }
            }}
          />
        </>
      )}
    </>
  );
};

export default AddItemToCartForm;
